import countries from '../data/tier1Contries'
import store from '../store'

export const getCookie = function (name) {
  let value = document.cookie
  let start = value.indexOf(` ${name}=`)
  if (start === -1) {
    start = value.indexOf(`${name}=`)
  }
  if (start === -1) {
    value = null
  } else {
    start = value.indexOf('=', start) + 1
    let end = value.indexOf(';', start)
    if (end === -1) {
      end = value.length
    }
    value = unescape(value.substring(start, end))
  }
  return value
}

export const setCookie = function (name, val, exDays) {
  const exDate = new Date()
  exDate.setDate(exDate.getDate() + exDays)
  const value =
    escape(val) + (exDays == null ? '' : `; expires=${exDate.toUTCString()}`)
  document.cookie = `${name}=${value}`
}

export const setTierSupport = function (tierSupport = false) {
  const code = store.getters['account/getUserCountry']
  const tier = window.EWA.ANALYTICS.getConfigBooleanValue('tier_support')

  if (tier || tierSupport) {
    if (Object.keys(countries).find((v) => code === v)) {
      localStorage.setItem('tier', 'tier1')
    } else {
      localStorage.setItem('tier', 'tier2')
    }
  } else localStorage.removeItem('tier')
}
